import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_ROUTE_RESET = 'POST_ROUTE_RESET';
export const POST_ROUTE_LOADING = 'POST_ROUTE_LOADING';
export const POST_ROUTE_SUCCESS = 'POST_ROUTE_SUCCESS';
export const POST_ROUTE_REJECT = 'POST_ROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const postRouteReset = () => ({ type: POST_ROUTE_RESET });
export const postRouteLoading = () => ({ type: POST_ROUTE_LOADING });
export const postRouteSuccess = (payload) => ({ type: POST_ROUTE_SUCCESS, payload });
export const postRouteReject = (payload) => ({ type: POST_ROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postRouteRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/Route/web/AddRoute`, options);
};


